import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import videojs from 'video.js';
import Vimeo from '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.cjs';

import 'videojs-markers';
import 'videojs-youtube';
import s from 'video.js/dist/video-js.min.css';

import fi from './fi.json';
import sv from './sv.json';

Vimeo.prototype.load = () => {};
Vimeo.prototype.preload = () => {};
Vimeo.prototype.reset = () => {};

require('@silvermine/videojs-quality-selector')(videojs);

@withStyles(s)
export default class VideoPlayer extends React.Component {
  static propTypes = {
    onReady: PropTypes.func.isRequired,
    onUnmount: PropTypes.func,
    poster: PropTypes.string,
    playsInline: PropTypes.bool,
    muted: PropTypes.bool,
    goToNextSection: PropTypes.node,
    youtube: PropTypes.shape({}),
    onSetup: PropTypes.func,
    disableMainPadding: PropTypes.bool,
    disableHeaderPadding: PropTypes.bool,
    disableMargin: PropTypes.bool,
    controls: PropTypes.bool,
  };

  static defaultProps = {
    poster: undefined,
    onUnmount: () => null,
    goToNextSection: undefined,
    playsInline: false,
    muted: false,
    youtube: null,
    onSetup: () => null,
    disableMainPadding: false,
    disableHeaderPadding: false,
    disableMargin: false,
    controls: true,
  };

  componentDidMount() {
    const {
      onReady,
      onSetup,
      disableMainPadding,
      disableHeaderPadding,
      disableMargin,
      ...rest
    } = this.props;
    const options = { techOrder: ['vimeo', 'youtube', 'html5'], ...rest };

    videojs.addLanguage('fi-FI', fi);
    videojs.addLanguage('sv-SE', sv);

    videojs.hook('setup', onSetup);

    // instantiate Video.js
    this.player = videojs(this.videoNode, options, function onPlayerReady() {
      this.resizeVideoJS = () => {
        const el = this.el_; // eslint-disable-line no-underscore-dangle
        let aspectRatio;
        if (_.get(this, 'tech_.ytPlayer')) {
          aspectRatio =
            _.get(this, 'tech_.ytPlayer.g.g.height', 0) /
            _.get(this, 'tech_.ytPlayer.g.g.width', 0);
        } else if (_.get(this, 'tech_._player')) {
          aspectRatio =
            _.get(this, 'tech_._player.element.height', 0) /
            _.get(this, 'tech_._player.element.width', 0);
        } else {
          aspectRatio = this.videoHeight() / this.videoWidth();
        }

        const header = document.querySelector('header');
        const main = document.querySelector('main');
        const videoNoteBtn = document.querySelector('#add-video-note-btn');
        const videoNoteBtnHeight =
          ((videoNoteBtn && videoNoteBtn.offsetHeight) || 40) + 10;
        let headerHeight = (header && header.offsetHeight) || 55;
        if (disableHeaderPadding) {
          headerHeight = 0;
        }
        let mainPadding =
          (main &&
            parseInt(
              window
                .getComputedStyle(main, null)
                .getPropertyValue('padding-top'),
              10,
            )) ||
          15;
        if (disableMainPadding) {
          mainPadding = 0;
        }
        const restMargins = 20;

        let width = el.parentElement.offsetWidth;
        let height = el.parentElement.offsetHeight;

        const margin = width > 992 ? 24 : 0;
        if (!disableMargin) {
          width -= margin;
        }

        if (Number.isNaN(aspectRatio)) {
          this.width(width);
          return;
        }

        if (window.innerWidth < 992) {
          let newWidth = width;
          let newHeight = width * aspectRatio;

          if (
            newHeight + headerHeight + mainPadding + restMargins >
            window.innerHeight
          ) {
            newHeight =
              window.innerHeight - headerHeight - mainPadding - restMargins;
            newWidth = newHeight / aspectRatio;
          }

          this.width(newWidth);
          this.height(newHeight);
          return;
        }

        const calculatedHeight = width * aspectRatio;
        height -= videoNoteBtnHeight;

        if (calculatedHeight > height) {
          this.width(height / aspectRatio);
          this.height(height);
        } else {
          this.width(width);
          this.height(calculatedHeight);
        }
      };

      window.addEventListener('resize', this.resizeVideoJS);

      this.resizeVideoJS();
      this.on('loadedmetadata', () => {
        this.resizeVideoJS();
      });

      onReady(this);
    });

    this.player.on('play', () => {
      if (this.props.youtube && this.player.getChild('LoadingSpinner')) {
        this.player.removeChild('LoadingSpinner');
      }
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    this.props.onUnmount();
    window.removeEventListener('resize', this.player.resizeVideoJS);
    // this.player.dispose();
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    const { muted, playsInline, controls } = this.props;
    return (
      <div data-vjs-player>
        <div>{this.props.goToNextSection}</div>
        <video // eslint-disable-line jsx-a11y/media-has-caption
          className="video-js vjs-default-skin"
          controls={controls}
          preload="auto"
          // type={this.props.mimetype} // `${mimetype} codecs="H.264/MPEG-4"` // possible solution with codecs
          poster={this.props.poster}
          ref={node => {
            this.videoNode = node;
          }}
          muted={muted}
          playsInline={playsInline}
        />
      </div>
    );
  }
}
